import { FncNullable } from './SdkCommon';

export class TokenizedEventFunction {
    READY: FncNullable;
    VALIDATION_CHANGED: FncNullable;
    TOKENIZED: FncNullable;
    SUBMITED: FncNullable;
    ERROR: FncNullable;
    
    constructor() {
        this.READY = undefined;
        this.VALIDATION_CHANGED = undefined;
        this.TOKENIZED = undefined;
        this.SUBMITED = undefined;
        this.ERROR = undefined;
    }
}
